import { LegacyMap } from './prism-new-legacy-maps.helpers';

/**
 * Lead Finder's calling-team lists. The CRM was written for prism-new's own body here, so `data` passes
 * through as it came; only the page total is carried over (as `pagination`), since the legacy shape
 * drops `meta` and the lists could never page past the first page without it.
 */
const keepPage: LegacyMap = (d, ctx) => ({ data: d, pagination: ctx.meta });

export const LEAD_AGENTS_LEGACY_MAPS: Record<string, LegacyMap> = {
  'GET /lead-agents': keepPage,
  'GET /lead-agents/my-leads': keepPage,
  'GET /lead-agents/unassigned-leads': keepPage,
};
